import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Accordion, AccordionBody, AccordionHeader } from '@components/accordion';

export const MultiOfferHeader = ({
  instructionsDescription,
  instructionsTitle,
  formName,
}: {
  instructionsDescription: string;
  instructionsTitle: string;
  formName: string;
}) => {
  const { t } = useTranslation();
  const {
    formState: { errors },
  } = useFormContext();
  const formErrors = errors?.[formName];
  const textAreaErrors = (formErrors?.message as string) ?? '';
  const errorsCount = textAreaErrors.split('\n').length;
  return (
    <>
      <Accordion className='bg-secondary border-none'>
        <AccordionHeader className='text-subtitle-m'>{instructionsTitle}</AccordionHeader>
        <AccordionBody>
          <span className='whitespace-pre-line'>{instructionsDescription}</span>
        </AccordionBody>
      </Accordion>
      {formErrors && (
        <Accordion className='border-none' defaultOpen>
          <AccordionHeader className='text-subtitle-m text-critical-no-bg bg-critical'>
            {errorsCount} {errorsCount > 1 ? t('errors:error_plural') : t('errors:error')}
          </AccordionHeader>
          {textAreaErrors && (
            <AccordionBody className='text-body-m text-critical-no-bg bg-critical'>
              <pre className='text-body-xs whitespace-pre-line'>{textAreaErrors}</pre>
            </AccordionBody>
          )}
        </Accordion>
      )}
    </>
  );
};
